import React from 'react';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { useLayoutPrefs } from '../layoutPrefs';

export const LeftbarToggle: React.FC = () => {
  const { leftCollapsed, toggleLeft } = useLayoutPrefs();
  const Icon = leftCollapsed ? PanelLeftOpen : PanelLeftClose;
  const label = leftCollapsed ? 'Expand sidebar' : 'Collapse sidebar';

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleLeft}
      className="h-7 w-7 text-muted-foreground hover:text-foreground shrink-0"
      aria-label={label}
      aria-pressed={!leftCollapsed}
      title={`${label} ( [ )`}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
};
